import { watchFetchOpenOrders } from './fetchSalesDashboard';

export const dashboardSagas = [watchFetchOpenOrders()];
